module.exports = __webpack_public_path__ + "img/stock0.29a9bd74.png";